import styled from "styled-components";

export const SkeletonWrapper = styled.div<{ $opaque?: boolean }>`
  position: relative;
  width: fit-content;
  height: fit-content;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.default[100]};
  overflow: clip;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    animation: shine 3s infinite;
    background: linear-gradient(
      90deg,
      transparent,
      ${({ theme }) => theme.colors.default[50]},
      transparent
    );
  }

  > * {
    opacity: ${({ $opaque }) => ($opaque ? 0.2 : 0)};
    pointer-events: none;
  }

  // shine animation
  @keyframes shine {
    0% {
      left: -100%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }
`;
